import { UsageLimit } from 'components/voucher/voucher-create/usage-limit/UsageLimit'

export const UsageLimitContainer = ({ sectionRef, voucherDetail, onChangeForm, errorForm }) => {
    const onChangeUsageLimit = (item) => {
        const newItem = { ...voucherDetail?.limit, ...item }
        onChangeForm({ limit: newItem })
    }

    const props = {
        sectionRef: sectionRef?.usage_limit,
        voucherDetail: voucherDetail?.limit,
        onChangeUsageLimit,
        errorForm,
    }

    return <UsageLimit {...props} />
}
